module.exports = __webpack_public_path__ + "static/media/zllc2.54c9240b.png";